import api from '../../api';
import { MilitaryUnit } from 'models/nostradamus/administration/MilitaryUnit';
import { plainToInstance } from 'class-transformer';

const apiUrl = 'api/analytics/military-units';

const getList = async (hideArchived = true, unitId = null) => {
    const params = { hideArchived };
    if (unitId && unitId !== 'undefined') {
        params.unitId = unitId;
    }
    const { data } = await api.get(apiUrl, { params });
    const responseData = data?.body || data;
    // Return units array for backwards compatibility, but also expose viewport info
    const units = responseData?.data || responseData;
    units.centerPoint = responseData?.centerPoint;
    units.zoomLevel = responseData?.zoomLevel;
    return units;
};

const getEntity = async (id) => {
    const { data } = await api.get(`${apiUrl}/${id}`);
    return plainToInstance(MilitaryUnit, data.body || data, {
        exposeDefaultValues: true,
    });
};

const create = async (data) => {
    return await api.post(apiUrl, data);
};

const update = async (data, id) => {
    return await api.put(`${apiUrl}/${id}`, data);
};

const remove = async (id) => {
    return await api.delete(`${apiUrl}/${id}`);
};

const archive = async (id) => {
    return await api.put(`${apiUrl}/${id}/archive`);
};

const restore = async (id) => {
    return await api.put(`${apiUrl}/${id}/restore`);
};

const getUnitTypes = async () => {
    const { data } = await api.get(`${apiUrl}/types`);
    return data?.body || data;
};

const getUnitNames = async (unitType) => {
    const { data } = await api.get(`${apiUrl}/names`, {
        params: { unitType },
    });
    return data?.body || data;
};

const updatePolygon = async (unitId, polygon) => {
    return await api.put(`${apiUrl}/${unitId}/polygon`, { polygon });
};

const deletePolygon = async (unitId) => {
    return await api.delete(`${apiUrl}/${unitId}/polygon`);
};

const MilitaryUnitService = {
    getList,
    getEntity,
    create,
    update,
    delete: remove,
    archive,
    restore,
    getUnitTypes,
    getUnitNames,
    updatePolygon,
    deletePolygon,
    getModel: () => MilitaryUnit,
};

export default MilitaryUnitService;
